import type { ParentProps } from "solid-js";
import clsx from "~/util/html/style";

// A flex container takes its baseline from its first flex item, and an svg has no text baseline —
// the browser synthesizes one at the box edge, so icon-first content sits a couple of pixels off
// under `items-baseline`. Wrapping the icon here puts a zero-width space first, supplying a real
// text baseline in the surrounding font so the row aligns on text, not on the icon's bottom edge.
// The space is aria-hidden so it stays out of the accessible name of whatever it sits inside.
export function BaselineAligner(props: ParentProps<{ class?: string }>) {
  return (
    <div class={clsx("flex items-center", props.class)}>
      <span aria-hidden="true">&ZeroWidthSpace;</span>
      {props.children}
    </div>
  );
}
